import { render } from "./ConversationHistory.vue?vue&type=template&id=5edccf4d&scoped=true"
import script from "./ConversationHistory.vue?vue&type=script&lang=js"
export * from "./ConversationHistory.vue?vue&type=script&lang=js"

import "./ConversationHistory.vue?vue&type=style&index=0&id=5edccf4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edccf4d"]])

export default __exports__